import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseHttpService } from '../httpservice.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class UdeAdminService extends BaseHttpService<any> {

  getAllCategories(brand: string, country: string) {
    const url = `${this.url}/all-categories`;
    const params = new HttpParams()
      .set('country', country)
      .set('brand', brand);
    return this.client.get<any>(url, { params });
  }

  deleteLink(id: string) {
    const url = `${this.url}/link`;
    const params = new HttpParams().set('linkId', id);
    return this.client.delete(url, { params });
  }

  getAllLinks() {
    const url = `${this.url}/all-links`;
    return this.fetchAll(url);
  }

  updateCategory(data: any) {
    const url = `${this.url}/category`;
    return this.client.put<any>(url, data);
  }

  addCategory(data: any) {
    const url = `${this.url}/category`;
    return this.create(data, url);
  }

  updateLink(data: any) {
    const url = `${this.url}/link`;
    return this.client.put<any>(url, data);
  }

  addNewLink(data: any) {
    const url = `${this.url}/link`;
    return this.create(data, url);
  }

  deleteCategory(id: string) {
    const url = `${this.url}/category`;
    const params = new HttpParams().set('categoryId', id);
    return this.client.delete(url, { params });
  }

  bulkUpdateCategoryLinks(data: any) {
    const url = `${this.url}/move-category-links`;
    return this.client.post<any>(url, data);
  }

  fetchAllCategories(): Promise<any> {
    const url = `${this.url}/all-categories`;
    return firstValueFrom(this.fetchAll(url));
  }

  reorderCategories(data: { _id: string; display_order: number }[]) {
    const url = `${this.url}/reorder-categories`;
    return this.client.put<any>(url, data);
  }
}